export const baseURL = "https://teenpatti.nawarliveapp.top/";
export const adminBaseURL = "https://portal.nawarliveapp.top/";
export const key = "AauCc3J0rXzqlqJvJkLMzg";
